import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { POFISubwaySourceAndLayer } from "../SourcesAndLayers/TransportLines/POFISubwaySourceAndLayer";
import { POFITramSourceAndLayer } from "../SourcesAndLayers/TransportLines/POFITramSourceAndLayer";
import { POFITrainSourceAndLayer } from "../SourcesAndLayers/TransportLines/POFITrainSourceAndLayer";
import { TravelTimeLineSourceAndLayer } from "../SourcesAndLayers/TravelTimeLine/TravelTimeLineSourceAndLayer";
import { PolygonSourceAndLayer } from "../SourcesAndLayers/Polygon";
import { useMapContext } from "../../contexts/MapContext";
export const MapLayers = () => {
    const { isStyleLoaded } = useMapContext();
    if (!isStyleLoaded)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(PolygonSourceAndLayer, {}), _jsx(TravelTimeLineSourceAndLayer, {}), _jsx(POFISubwaySourceAndLayer, {}), _jsx(POFITramSourceAndLayer, {}), _jsx(POFITrainSourceAndLayer, {})] }));
};
